export default {
  localhost: "https://api.billing.jerald.dev",
  // localhost: "http://localhost:3000",
  uid: "",
  token: "",
  eventid: "",
  error: false,
  errorMessage: {
    type: "",
    message: "",
  },
  path: "/",
  isLoading: false,
  products: [],
  category: [],
  vendors: [],
  stockroom: [],
  shopdata: [],
  vendorProdList: [],
  stockdata: [],
  billstock: [],
  rules: {
    required: (value) => !!value || "Required.",
    mrp: (value) => {
      return value >= 1 || "SHOULD BE MORE THAN 1";
    },
    counter: (value) => value.length >= 3 || "Atleast 3 Letters",
    mobile: (value) => {
      const phone = /^\d{10}$/;
      return phone.test(value) || "ONLY 10 NUMBERS";
    },
    address: (value) => value.length >= 5 || "Atleast 5 Letters",
    email: (value) => {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return pattern.test(value) || "Invalid e-mail.";
    },
  },
  allBills: [],
  billItems: {},
  onlineCat: [],
  onlineProd: [],
  onlineOrders: [],
  onlineOrdersItems: [],
};
